export default {
	操作成功: '操作成功',
	操作失败: '操作失败',
	产品: '产品',
	当余额不足时使用信用卡自动续费: '当余额不足时使用信用卡自动续费',
	订单: '订单',
	订单自动续费: '订单自动续费',
	概览: '概览',
	个: '个',
	更换: '更换',
	获取全部: '获取全部',
	解除自动扣款: '解除自动扣款',
	确认解除自动扣款吗: '确认解除该信用卡的自动扣款吗？',
	使用信用卡: '使用信用卡',
	使用账户余额: '使用账户余额',
	首选信用卡: '首选信用卡',
	搜索订单号或IP: '搜索订单号或IP',
	未设置: '未设置',
	下次续费: '下次续费',
	下次续费日期: '下次续费日期',
	下次支付日期: '下次支付日期',
	续费订单: '续费订单',
	续费记录: '续费记录',
	账单周期: '账单周期',
	扣款方式: '扣款方式',
	失败原因: '失败原因',
	续费日历: '续费日历',
	选择信用卡: '选择信用卡',
	优先使用可用余额进行自动续费: '优先使用可用余额进行自动续费',
	暂无订单: '暂无订单',
	账户余额: '账户余额',
	自动续费: '自动续费',
	自动续费费用: '自动续费费用',
	自动续费服务: '自动续费服务',
	自动续费设置: '自动续费设置',
	自动续费说明:
		'订单到期前3天将会自动生成账单，已开通自动续费的订单将尝试自动扣款，根据您的配置，使用账户余额、设置好的信用卡，按顺序或使用其中一种方式扣款！',
}
